import Vue from 'vue';
import Router from 'vue-router';

// Pages
import Home from '../../pages/index.vue';
import Login from '../../pages/login/index.vue';

Vue.use(Router);

// Pages
const accounts = () => import(/* webpackChunkName: "accounts-page" */ '../../pages/accounts/index.vue');

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: '/login',
      children: [
        {
          path: '/accounts', name: 'accounts', component: accounts, menu: true, label: 'menu.accounts',
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
  ],
});
